import React, { useState, useMemo } from 'react';
import Pagination from '@cashew/pagination';
import Box from '@cashew/box';
import Title from '@cashew/title';
import List from '@cashew/list';
import { TFunction } from 'i18next';
import TransactionItem from '@cashew/transaction-item';

interface Transaction {
  currencyCode: string;
  createdAt: string;
  transactionId: string;
  isBalance: string;
  totalAmount: number;
  transactionType: string;
  transactionStatus: 'PENDING' | 'PROCESSED';
}

interface ListTransactionsProps {
  ns: string;
  transactionList: Transaction[];
  showTransactionDetails?: any;
  transactionSelected?: number;
  t: TFunction;
}

const ListTransactions = ({
  ns,
  transactionList,
  showTransactionDetails,
  transactionSelected,
  t,
}: ListTransactionsProps) => {
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const perPageFilteredList = useMemo(() => {
    const start = pageNumber * pageSize;
    return transactionList.slice(start, start + pageSize);
  }, [transactionList, pageNumber, pageSize]);

  return (
    <>
      <Title>{t('transactionsList.title')}</Title>
      <Box withHeader className={`${ns}__box transactions-list`}>
        <div className={`${ns}__list-pagination`}>
          <div className={`${ns}__headers`}>
            <p>{t('transactionsList.paymentsList.column.reference')}</p>
            <p>{t('transactionsList.paymentsList.column.settlementId')}</p>
            <p>{t('transactionsList.paymentsList.column.type')}</p>
            <p>{t('transactionsList.paymentsList.column.status')}</p>
            <p>{t('transactionsList.paymentsList.column.totalAmount')}</p>
          </div>
          <List
            component={TransactionItem}
            data={perPageFilteredList}
            onClick={showTransactionDetails}
            selected={transactionSelected}
            t={t}
          />
          <Pagination
            records={transactionList.length}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            changePageSize={setPageSize}
          />
        </div>
      </Box>
    </>
  );
};

ListTransactions.defaultProps = {
  showTransactionDetails: undefined,
  transactionSelected: undefined,
};

export default ListTransactions;
